import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'
import { finalize } from 'rxjs/operators'
import { ApiService } from 'src/app/services/api.service'
import { UiService } from 'src/app/services/ui.service'
import { handleArpioError } from 'src/utils/handle-error'
import { subscriptionActive } from 'src/utils/rxjs-utils'

@Component({
  selector: 'accept-invite',
  templateUrl: './auth-accept-invite.component.html',
  styleUrls: ['./auth-accept-invite.component.scss'],
  standalone: false,
})
export class AuthAcceptInviteComponent implements OnInit, OnDestroy {
  invalidContext = false
  inviter: string = null
  previewInviteSubscription: Subscription = null
  acceptInviteSubscription: Subscription = null

  constructor(
    private apiService: ApiService,
    private uiService: UiService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    if (!this.activatedRoute.snapshot.queryParams['inviteToken']) {
      this.invalidContext = true
    } else {
      let inviteToken = this.activatedRoute.snapshot.queryParams['inviteToken']
      this.previewInviteSubscription = this.apiService
        .previewInvite(inviteToken)
        .pipe(finalize(() => (this.previewInviteSubscription = null)))
        .subscribe(
          (previewInviteResponse) => {
            this.inviter = previewInviteResponse.inviterEmail
          },
          handleArpioError(window.location.href, this.apiService, this.uiService)
        )
    }
  }

  ngOnDestroy() {
    if (!!this.previewInviteSubscription && !this.previewInviteSubscription.closed) {
      this.previewInviteSubscription.unsubscribe()
    }
    if (!!this.acceptInviteSubscription && !this.acceptInviteSubscription.closed) {
      this.acceptInviteSubscription.unsubscribe()
    }
  }

  acceptInviteClick() {
    let inviteToken = this.activatedRoute.snapshot.queryParams['inviteToken']
    let finalizeUrl = this.uiService.buildFinalizeInviteUrl()

    // submit the invite to the server and navigate to the appropriate login page
    this.acceptInviteSubscription = this.apiService
      .startAcceptInviteFlow(inviteToken, finalizeUrl)
      .pipe(finalize(() => (this.acceptInviteSubscription = null)))
      .subscribe(
        (loginUrl) => {
          window.location.href = loginUrl
        },
        handleArpioError(window.location.href, this.apiService, this.uiService)
      )
  }

  get acceptingInvite() {
    return subscriptionActive(this.acceptInviteSubscription)
  }
}
